<style lang="stylus">
    .focus-tool-shapecontainer
        width 160px
        background var(--bg-color-tertiary)
        padding-bottom 8px
        border-bottom-left-radius 5px
        border-bottom-right-radius 5px
        .focus-tool-item
            &:first-child
                &:after
                    display block
                    margin 0 auto
                    content ''
                    width 128px
                    height 1px
                    background var(--bg-color-focus-tool-box-active)
            p
                width 100%
                height 40px
                line-height 40px
                padding 0 16px
                font-size 12px
                cursor pointer
                text-overflow ellipsis
                white-space nowrap
                overflow hidden
                &.active
                    background var(--bg-color-focus-tool-box-active)
                &:not(.active):hover
                    background var(--bg-color-focus-tool-box-hover)
            .focus-tool-itemimg
                padding 0 10px
                display flex
                flex-wrap wrap
                .isActiveShape
                    background var(--bg-color-focus-tool-box-active)
                div
                    width 34px
                    height 34px
                    padding 6px
                    &:hover
                        background var(--bg-color-focus-tool-box-active)
                    img
                        width 24px
                        height 24px
</style>

<template>
    <DragBox
        :dragTitle="dragTitle"
        :originPostion="{ left: `${originPostion.left}px`, top: `${originPostion.top}px` }"
        :style="{ width: '160px', left: `${originPostion.left}px`, top: `${originPostion.top}px` }"
        :showModal="showModal"
        :lockBox="lockBox"
        @changeLock="changeLock($event)"
        @removeCloseEvent="removeCloseListener()"
        @updateBoxPos="updateBoxPos($event)"
        @closeBox="closeEvent()"
    >
        <div id="quickShape" class="focus-tool-shapecontainer" v-if="focusShapeLoadFlag">
            <div class="focus-tool-item" v-for="(item, index) in focusShapeData" :key="item.id">
                <p class="focus-tool-itemname" :class="{ active: activeIndex == item.id }" @click.stop="selectBar(index)" :title="$t(item.name)">
                    {{ $t(item.name) }}
                </p>
                <collapseTransition>
                    <div class="focus-tool-itemimg" v-show="activeIndex == item.id">
                        <div
                            v-for="(img, index) in item.data"
                            class="library-shape"
                            :class="{ isActiveShape: img.shape == activeImgShape }"
                            :key="index"
                            @dblclick.prevent="dbClickImg($event, img.shape, img.imgname, img[lang], index)"
                            @mousedown="selectImg($event, img.shape, img.imgname, img[lang], index)"
                        >
                            <img v-if="img.url" :src="img.url" draggable="false" :title="img[lang] ? img[lang] : img.imgname" />
                            <div v-else class="library-noimage">no image</div>
                        </div>
                    </div>
                </collapseTransition>
            </div>
        </div>
    </DragBox>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import collapseTransition from "@/public/utils/collapse-transition.js";
    import DragBox from "../Tabs/NavigationDragBox.vue";

    @Component({
        components: {
            DragBox,
            collapseTransition,
        },
    })
    export default class FocusExpandToolShape extends Vue {
        @Prop()
        index;
        @Prop()
        dragTitle;
        @Prop()
        showModal;
        @Prop()
        originPostion;
        @Prop()
        lockBox;

        activeIndex = 0;
        activeImgShape: string = "";
        updateBoxPos(pos) {
            this.$emit("updateBoxPos", pos);
        }
        changeLock(e) {
            e && this.$emit("changeLock", this.index);
        }
        removeCloseListener() {
            this.$emit("removeCloseEvent", this.index);
        }
        closeEvent() {
            this.$emit("closeBox", this.index);
        }
        loadFromDb() {
            let opendb = window.indexedDB.open("QuickShape");
            let nameList = ["basic-shapes", "flowchart-shapes"];
            opendb.onsuccess = (e) => {
                let shapeList = [
                    {
                        id: 0,
                        name: "basic",
                        data: [],
                    },
                    {
                        id: 1,
                        name: "flowchart",
                        data: [],
                    },
                ];
                let db = (e.target as IDBOpenDBRequest).result;
                const tableNames = db.objectStoreNames;
                for (let i = 0; i < nameList.length; i++) {
                    let tablename = nameList[i];
                    if (!tableNames.contains(tablename)) {
                        continue;
                    }
                    let transaction = db.transaction(tablename);
                    let store = transaction.objectStore(tablename);
                    let request = store.openCursor();
                    let tempData = shapeList[i];
                    request.onsuccess = (e) => {
                        let cursor = (e.target as IDBRequest).result;
                        if (cursor) {
                            let cursordata = cursor.value;
                            let cursorkey = cursor.key;
                            let tempIMG = cursordata.data.match(/!\[CDATA\[[^\[\]]*?\]\]/g);
                            if (cursorkey == 0) {
                                tempData.data[0] = {
                                    table_index: cursordata.index,
                                    imgname: cursordata.name,
                                    zh: cursordata.zh_name,
                                    de: cursordata.de_name,
                                    en: cursordata.en_name,
                                    es: cursordata.es_name,
                                    fr: cursordata.fr_name,
                                    jp: cursordata.jp_name,
                                    ru: cursordata.ru_name,
                                    it: cursordata.it_name,
                                    pt: cursordata.pt_name,
                                    tw: cursordata.tw_name,
                                    kr: cursordata.kr_name,
                                    url: cursordata.blob && URL.createObjectURL(cursordata.blob),
                                    blob: cursordata.blob,
                                    shape: cursordata.data,
                                    table_id: cursordata.tableID,
                                    tempIMG: tempIMG ? tempIMG : [],
                                    next: cursordata.next,
                                };
                            } else {
                                let obj = {
                                    table_index: cursordata.index,
                                    imgname: cursordata.name,
                                    zh: cursordata.zh_name,
                                    de: cursordata.de_name,
                                    en: cursordata.en_name,
                                    es: cursordata.es_name,
                                    fr: cursordata.fr_name,
                                    jp: cursordata.jp_name,
                                    ru: cursordata.ru_name,
                                    it: cursordata.it_name,
                                    pt: cursordata.pt_name,
                                    tw: cursordata.tw_name,
                                    kr: cursordata.kr_name,
                                    url: cursordata.blob && URL.createObjectURL(cursordata.blob),
                                    blob: cursordata.blob,
                                    shape: cursordata.data,
                                    table_id: cursordata.tableID,
                                    tempIMG: tempIMG ? tempIMG : [],
                                    next: cursordata.next,
                                };
                                tempData.data.push(obj);
                            }
                            cursor.continue();
                        } else {
                            this.focusShapeData = shapeList;
                            this.focusShapeLoadFlag = true;
                        }
                    };
                }
                db.close();
            };
            opendb.onerror = (e) => {
                console.log(e);
            };
        }
        selectBar(index) {
            this.activeIndex = index;
        }
        get focusShapeLoadFlag() {
            return this.$store.state.ui.focusShapeLoadFlag;
        }
        set focusShapeLoadFlag(v) {
            this.$store.commit("setStatus", {
                type: "focusShapeLoadFlag",
                data: v,
            });
        }
        get focusShapeData() {
            return this.$store.state.ui.focusShapeData;
        }
        set focusShapeData(v) {
            this.$store.commit("setStatus", {
                type: "focusShapeData",
                data: v,
            });
        }

        /**选择图片 */
        get focusModeExpandTop() {
            return this.$store.getters.expandTop;
        }
        get focusModeExpandLeft() {
            return this.$store.getters.expandLeft;
        }
        get sceneTop() {
            if (!this.focusModeExpandTop) return 0;
            return this.$store.state.ui.sceneTop;
        }
        get sceneLeft() {
            if (!this.focusModeExpandLeft) return 0;
            return this.$store.state.ui.sceneLeft;
        }
        currentShapeIndex = 0;
        mouseUpEvent() {
            // 特殊处理iframe遮挡document丢失问题
            this.removeImg();
            document.onmousemove = null;
            document.onmouseup = null;
        }
        selectImg(e, shape, name, langName, id) {
            this.activeImgShape = shape;
            e.stopPropagation();
            if (e.button == 2) {
                return;
            } // 右键返回
            window["_view"]._tool.endEdit();
            let baseDomInfo = (document.getElementById("quickShape").parentNode as HTMLElement).getBoundingClientRect();
            let baseLeft = baseDomInfo["x"];
            let baseTop = baseDomInfo["y"];
            let baseRange = { x: [0, baseDomInfo.width], y: [0, baseDomInfo.height] };
            this.currentShapeIndex = id;
            let target = e.target;
            let x = e.pageX;
            let y = e.pageY;
            this.drawImg(target, x, y);
            let a = document.getElementById("previewIMG");
            a.style.display = "none";
            let changeShapeFlag = false;
            let dropX, dropY;
            document.onmousemove = (ev) => {
                console.log(ev);
                ev.stopPropagation();
                if (ev.pageX - e.pageX == 0 || ev.pageY - e.pageY == 0) return false;
                a.style.display = "block";
                let movex = ev.pageX - x - baseLeft;
                let movey = ev.pageY - y - baseTop;
                console.log(x + movex, baseRange.x[0], baseRange.x[1], "----", y + movey, baseRange.y[0], baseRange.y[1]);
                if (x + movex < baseRange.x[0] || x + movex > baseRange.x[1] || y + movey < baseRange.y[0] || y + movey > baseRange.y[1]) {
                    let obj = {
                        x: x + movex + baseLeft - this.sceneLeft,
                        y: y + movey + baseTop - this.sceneTop,
                    };
                    if (!changeShapeFlag) {
                        // 移出的时候，一次性删除原预览图
                        this.removeImg();
                        changeShapeFlag = true;
                        let dragID = this.activeIndex == 1 ? 4 : 0; // 基本流程图对应库
                        let symbolList = [
                            {
                                shape: shape,
                                name: name,
                                langName: langName,
                                obj,
                                dragID,
                            },
                        ];
                        window["_view"].dragEnter(symbolList);
                        // window['_view'].dragEnter(shape, name, langName, obj, dragID)
                        this.$emit("stopCloseEvent", true);
                    }
                    window["_view"].dragMove(ev);
                } else {
                    if (changeShapeFlag) {
                        // 移回的时候，恢复原预览图
                        this.$emit("stopCloseEvent", false);
                        window["_view"].dragLeave();
                        this.drawImg(target, x, y);
                        a = document.getElementById("previewIMG");
                        changeShapeFlag = false;
                    }
                    a.style.left = x + movex - 16 + "px";
                    a.style.top = y + movey - 16 + "px";
                }
                dropX = x + movex;
                dropY = y + movey;
                return false;
            };
            document.onmouseup = (ev) => {
                ev.stopPropagation();
                let obj = {
                    x: dropX,
                    y: dropY,
                };

                window["_view"].dropToScene(ev);
                this.removeImg();
                document.onmousemove = null;
                document.onmouseup = null;
                window["_view"].updateRulers();
                this.$emit("stopCloseEvent", true);
                return false;
            };
            return false;
        }
        drawImg(img, x, y) {
            let a = document.getElementById("quickShape");
            let preview = img.cloneNode(true);
            preview.id = "previewIMG";
            preview.style.cssText = `position:absolute;left:${x}px;top:${y}px;max-width: 64px;max-height: 64px;object-fit:contain`;
            a.appendChild(preview);
        }
        removeImg() {
            let a = document.getElementById("quickShape");
            let b = document.getElementById("previewIMG");
            if (b) {
                a.removeChild(b);
            }
        }
        dbClickImg(e, shape, name, langName, id) {
            // 双击
            window["_view"]._tool.endEdit();
            window["_view"].libDbClickAddShape(shape, name, langName, 0);
        }

        mounted() {
            console.log(2222, this.lockBox);
            if (!this.focusShapeLoadFlag) {
                this.loadFromDb();
            }
        }

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "basic": "基本形状",
    "flowchart": "流程图形状"
  },
  "en": {
    "basic": "Basic Drawing Shapes",
    "flowchart": "Flowchart Shapes"
  },
  "fr": {
    "basic": "Formes de dessin de base",
    "flowchart": "Formes d'organigramme"
  },
  "de": {
    "basic": "Basis Zeichenformen",
    "flowchart": "Flowchart-Formen"
  },
  "jp": {
    "basic": "基本形状",
    "flowchart": "フローチャートの形状"
  },
  "es": {
    "basic": "Formas Básicas de Dibujo",
    "flowchart": "Formas de Diagrama de Flujo"
  },
  "pt": {
    "basic": "Formas básicas de desenho",
    "flowchart": "Formas de fluxograma"
  },
  "it": {
    "basic": "Forme di Disegno di Base",
    "flowchart": "Forme del Diagramma di Flusso"
  },
  "tw": {
    "basic": "基本繪圖形狀",
    "flowchart": "流程圖形狀"
  },
  "kr": {
    "basic": "기본 모양",
    "flowchart": "플로우차트 모양"
  }
}
</i18n>
